import AllowedDaysRules from 'pages/discounts/rules/types/AllowedDaysRules';
import CategoryLimitRule from 'pages/discounts/rules/types/CategoryLimitRule';
import DatesRule from 'pages/discounts/rules/types/DatesRule';
import DurationRule from 'pages/discounts/rules/DurationRule';
import ProductAttributeRule from 'pages/discounts/rules/ProductAttributeRule';
import TimeRule from 'pages/discounts/rules/TimeRule';
import EmailDomainRule from 'pages/discounts/rules/types/EmailDomainRule';
import MembershipRule from 'pages/discounts/rules/types/MembershipRule';

const applianceRuleTypes = [
    'applianceBookingAllowedDays',
    'applianceBookingAllowedTimes',
    'applianceBookingDuration',
    'applianceBookingProductAttributeCount',
    'applianceProductAttribute',
    'applianceProductCategoryLimit',
];

const conditionsRuleTypes = [

    /**
     *  Unsupported types
     * 'conditionBookingAttribute',
     * 'conditionBookingGap',
     * 'conditionBookingMaximumArrivalDate',
     */
    'conditionBookingAllowedDays',
    'conditionBookingAllowedTimes',
    'conditionBookingDates',
    'conditionBookingEmailDomain',
    'conditionBookingDuration',
    'conditionBookingProductAttributeCount',
    'conditionMembership',
    'conditionProductAttribute',
    'conditionBookingMaximumArrivalDate',
];

const components = {
    // Appliance
    applianceBookingAllowedDays: AllowedDaysRules,
    applianceBookingAllowedTimes: TimeRule,
    applianceBookingDuration: DurationRule,
    applianceBookingProductAttributeCount: ProductAttributeRule,
    applianceProductAttribute: ProductAttributeRule,
    applianceProductCategoryLimit: CategoryLimitRule,
    // Conditions
    conditionBookingAllowedDays: AllowedDaysRules,
    conditionBookingAllowedTimes: TimeRule,
    conditionBookingDuration: DurationRule,
    conditionBookingProductAttributeCount: ProductAttributeRule,
    conditionBookingAttribute: null, // BookingAttributeComponentType
    conditionBookingDates: DatesRule,
    conditionBookingEmailDomain: EmailDomainRule,
    conditionBookingGap: null, // GapComponentType
    conditionBookingMaximumArrivalDate: DurationRule, //  MaxArrivalDateComponentType
    conditionMembership: MembershipRule, // MembershipComponentType
    conditionProductAttribute: ProductAttributeRule,
};

/**
 * Returns an array with related rules to a type.
 *
 * @param {'appliance'|'condition'} type
 * @returns {string[]}
 */
export const getRuleTypes = (type) => {
    const rules = {
        appliance: applianceRuleTypes,
        condition: conditionsRuleTypes,
    };

    return rules[type];
};

/**
 * Returns configuration for ruleName.
 *
 * @typedef RuleConfiguration
 * @type {Object}
 * @property {Object} config
 * @property {string} type
 *
 * @param {string} ruleName
 * @returns {RuleConfiguration}
 */
export const getRuleConfig = (ruleName) => {
    const config = {
        // Appliance
        applianceBookingAllowedDays: {
            config: {
                value: null,
            },
            type: 'ApplianceBookingAllowedDays',
        },
        applianceBookingDuration: {
            config: {
                operator: null,
                value: null,
            },
            type: 'ApplianceBookingDuration',
        },
        applianceBookingAllowedTimes: {
            config: {
                value: null,
            },
            type: 'ApplianceBookingAllowedTimes',
        },
        applianceBookingProductAttributeCount: {
            config: {
                attribute: null,
                count: null,
                operator: null,
                value: null,
            },
            type: 'ApplianceBookingProductAttributeCount',
        },
        applianceProductAttribute: {
            config: {
                attribute: null,
                operator: null,
                value: null,
            },
            type: 'ApplianceProductAttribute',
        },
        applianceProductCategoryLimit: {
            config: {
                value: null,
            },
            type: 'ApplianceProductCategoryLimit',
        },
        // Conditions
        conditionBookingAllowedDays: {
            config: {
                value: null,
            },
            type: 'ConditionBookingAllowedDays',
        },
        conditionBookingDuration: {
            config: {
                operator: null,
                value: null,
            },
            type: 'ConditionBookingDuration',
        },
        conditionBookingAllowedTimes: {
            config: {
                value: null,
            },
            type: 'ConditionBookingAllowedTimes',
        },
        conditionBookingProductAttributeCount: {
            config: {
                attribute: null,
                count: null,
                operator: null,
                value: null,
            },
            type: 'ConditionBookingProductAttributeCount',
        },
        conditionBookingAttribute: {
            config: {
                attribute: null,
                operator: null,
            },
            type: 'ConditionBookingAttribute',
        },
        conditionBookingDates: {
            config: {
                attribute: null,
                value: null,
            },
            type: 'ConditionBookingDates',
        },
        conditionBookingEmailDomain: {
            config: {
                value: null,
            },
            type: 'ConditionBookingEmailDomain',
        },
        conditionBookingGap: {
            config: {
                value: null,
            },
            type: 'ConditionBookingGap',
        },
        conditionBookingMaximumArrivalDate: {
            config: {
                value: null,
            },
            placeholder: 'resources.products.duration.placeholders.duration_day',
            type: 'ConditionBookingMaximumArrivalDate',
        },
        conditionMembership: {
            config: {
                value: null,
            },
            type: 'ConditionMembership',
        },
        conditionProductAttribute: {
            config: {
                attribute: null,
                operator: null,
                value: null,
            },
            open: true,
            type: 'ConditionProductAttribute',
        },
    };

    return config[ruleName];
};

/**
 * Get component-type string from type.
 *
 * @param {string} type
 * @returns {string}
 */
export const getRuleComponentByType = (type) => {
    return components[type];
};



// WEBPACK FOOTER //
// ./src/helpers/rulesHelper.js